import { appUrl } from "@astro/config";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden hero-bg text-white px-6 md:px-24 py-12">
      <div className="absolute inset-0 bg-[radial-gradient(60%_55%_at_75%_42%,rgba(232,119,15,0.18),transparent_70%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(48%_50%_at_12%_88%,rgba(122,31,43,0.28),transparent_70%)]" />

      <div className="relative z-10 max-w-7xl sxl:max-w-400 mx-auto w-full grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 text-center lg:text-left flex flex-col items-center lg:items-start">
          <div className="flex items-center gap-3">
            <span className="text-xl text-secondary">ॐ</span>
            <span className="font-semibold text-[#E6C878] tracking-[0.28em] text-xs uppercase">॥ Divine Remedies ॥</span>
          </div>
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-heading leading-[1.1] tracking-tight uppercase font-normal text-[#FBF3E4]">
            BLESSED GEMS &amp; <br /><span className="text-gradient-gold font-bold">SACRED REMEDIES</span>
          </h1>
          <p className="text-sm md:text-base text-white/65 max-w-xl font-normal leading-relaxed">
            Lab-certified gemstones, energised Yantras, Rudraksha and puja essentials — each purified and blessed as per Vedic vidhi by Maharaj Ji.
          </p>

          <div className="grid grid-cols-2 gap-3 w-full max-w-xl pt-2">
            <div className="bg-white/4 border border-white/10 p-3.5 rounded-xl flex items-center gap-3 hover:border-[#E6C878]/40 transition group">
              <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-amber-500/10 border border-amber-500/30 rounded-lg text-secondary"><i className="fa-solid fa-gem text-base"></i></div>
              <div className="text-left min-w-0"><h4 className="text-xs text-[#FBF3E4] font-heading font-medium tracking-wide">GEMSTONES</h4><p className="text-[9px] text-[#E6C878]/55 font-semibold tracking-wider">CERTIFIED RATNA</p></div>
            </div>
            <div className="bg-white/4 border border-white/10 p-3.5 rounded-xl flex items-center gap-3 hover:border-[#E6C878]/40 transition group">
              <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-amber-500/10 border border-amber-500/30 rounded-lg text-secondary"><i className="fa-solid fa-star text-base"></i></div>
              <div className="text-left min-w-0"><h4 className="text-xs text-[#FBF3E4] font-heading font-medium tracking-wide">YANTRAS</h4><p className="text-[9px] text-[#E6C878]/55 font-semibold tracking-wider">ENERGISED</p></div>
            </div>
            <div className="bg-white/4 border border-white/10 p-3.5 rounded-xl flex items-center gap-3 hover:border-[#E6C878]/40 transition group">
              <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-amber-500/10 border border-amber-500/30 rounded-lg text-secondary"><i className="fa-solid fa-circle-dot text-base"></i></div>
              <div className="text-left min-w-0"><h4 className="text-xs text-[#FBF3E4] font-heading font-medium tracking-wide">RUDRAKSHA</h4><p className="text-[9px] text-[#E6C878]/55 font-semibold tracking-wider">SACRED MALAS</p></div>
            </div>
            <div className="bg-white/4 border border-white/10 p-3.5 rounded-xl flex items-center gap-3 hover:border-[#E6C878]/40 transition group">
              <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-amber-500/10 border border-amber-500/30 rounded-lg text-secondary"><i className="fa-solid fa-fire text-base"></i></div>
              <div className="text-left min-w-0"><h4 className="text-xs text-[#FBF3E4] font-heading font-medium tracking-wide">PUJA ITEMS</h4><p className="text-[9px] text-[#E6C878]/55 font-semibold tracking-wider">SAMAGRI</p></div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 pt-4 w-full sm:w-auto">
            <Link
              to="/products"
              className="bg-secondary hover:bg-amber-600 text-white font-bold px-8 py-4 rounded-full text-xs uppercase tracking-widest text-center shadow-lg transition duration-300"
            >
              Explore Collection <i className="fa-solid fa-arrow-right ml-1"></i>
            </Link>
            <a
              href={appUrl("jyotish")}
              className="border border-[#E6C878]/40 hover:border-[#E6C878] text-[#FBF3E4] font-bold px-8 py-4 rounded-full text-xs uppercase tracking-widest text-center transition duration-300"
            >
              Consult an Expert
            </a>
          </div>
        </div>

        {/* Rotating mandala */}
        <div className="relative hidden lg:flex items-center justify-center select-none">
          <div className="absolute w-[320px] h-80 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.15)_0%,transparent_70%)] blur-2xl animate-pulse" />
          <div className="w-95 h-95 border border-[#E6C878]/30 rounded-full flex items-center justify-center p-6 relative bg-linear-to-b from-black/5 to-black/30 backdrop-blur-[2px] shadow-[0_0_50px_rgba(230,200,120,0.05)]">
            <div className="absolute inset-0 border border-dashed border-[#E6C878]/20 rounded-full animate-[spin_120s_linear_infinite]" />
            <div className="absolute inset-4 border border-dotted border-[#E6C878]/15 rounded-full animate-[spin_80s_linear_infinite_reverse]" />

            {/* Gemstone medallions orbiting the outer edge */}
            <div className="absolute inset-0 animate-[spin_90s_linear_infinite] pointer-events-none">
              {[
                // size = medallion diameter in px — bump any one to enlarge that gem
                { src: "/images/stone_1.webp", name: "Yellow Sapphire (Pukhraj)", size: 48 },
                { src: "/images/stone_2.png", name: "Blue Sapphire (Neelam)", size: 70 },
                { src: "/images/stone_3.png", name: "Brown Zircon", size: 55 },
                { src: "/images/stone_4.webp", name: "Emerald (Panna)", size: 48 },
                { src: "/images/stone_5.png", name: "Hessonite (Gomed)", size: 48 },
                { src: "/images/stone_6.png", name: "Pearl (Moti)", size: 48 },
                { src: "/images/stone_7.png", name: "Ruby (Manik)", size: 55 },
                { src: "/images/stone_8.png", name: "Red Coral (Moonga)", size: 48 },
                { src: "/images/stone_9.webp", name: "Opal (Dudhiya Pathar)", size: 70 },
              ].map(({ src, name, size }, i) => {
                const angle = i * 40
                return (
                  <div key={src} className="absolute inset-0" style={{ transform: `rotate(${angle}deg)` }}>
                    <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 animate-[spin_90s_linear_infinite_reverse]">
                      <div
                        className="rounded-full overflow-hidden bg-transparent"
                        style={{ width: size, height: size, transform: `rotate(${-angle}deg)` }}
                      >
                        <img src={src} alt={name} title={name} className="w-full h-full object-cover" />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="w-full h-full relative flex items-center justify-center rounded-sm">
              {/* <div className="absolute inset-0 border border-[#E6C878]/30 transform rotate-90" /> */}
              {/* <div className="absolute inset-0 border border-[#E6C878]/30 transform rotate-45" /> */}
              <div className="absolute inset-0 animate-[spin_60s_linear_infinite_reverse]">
                <div className="absolute inset-y-0 left-1/4 w-1/2 border-x border-[#E6C878]/15 rounded-full" />
                <div className="absolute inset-x-0 top-1/4 h-1/2 border-y border-[#E6C878]/15 rounded-full" />
              </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="relative flex items-center justify-center w-24 h-24 rounded-full bg-[#120A05]/90 border border-[#E6C878]/30 shadow-[0_0_30px_rgba(242,160,7,0.2)]">
                <div className="absolute inset-2 rounded-full bg-[radial-gradient(circle,rgba(242,160,7,0.4)_0%,transparent_80%)] animate-ping opacity-75" style={{ animationDuration: '3s' }} />
                <span className="relative z-10 text-5xl text-[#F0D9A0] font-normal tracking-wide drop-shadow-[0_2px_15px_rgba(242,160,7,0.8)] select-none">ॐ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
